(function() {
    'use strict';
    angular.module('elogbooks.admin.charge-types', []);
})();
